import pagesNames from "../../constants/pages-names";

const strategyPageDataAr = {
    header : {
        image : {
            name : "arabian-woman.jpg",
            alt : "People talking",
        },
        title : "استراتيجيتنا للممارسات البيئية والاجتماعية والحوكمة المؤسسية",
        subtitle : "نعمل في بنك الأول على تجهيز إمكانيات التمويل لدعم التحول الشامل والمتنوع والمتوازن بما يساهم في بناء اقتصاد أكثر استدامة. ونقوم بذلك من خلال دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية في صميم استراتيجيتنا المؤسسية وأعمالنا، بالإضافة إلى الاستفادة من شراكتنا الاستراتيجية مع إتش إس بي سي.",
    },
    ceoSection : {
        image : {
            name : "",
            alt : "العضو المنتدب والرئيس التنفيذي (السيد توني كريبس)",
        },
        description : `بينما نسعى في بنك الأول إلى غرس الممارسات البيئية والاجتماعية والحوكمة المؤسسية في جوهر أعمالنا، وستبقى هذه الممارسات ضمن محور أولويات أعمالنا وعلاقاتنا مع أصحاب المصلحة. فنحن نتطلع إلى تطوير عملية صنع القرارات لدينا لنرتقي بها إلى ما هو أبعد من العوامل الاقتصادية، ونضع حماية الكوكب ومن يعيش عليه نصب أعيننا من أجل ضمان استمرارية أعمالنا.`,
        descriptionTwo : `وقد نجحنا بالفعل في دمج استراتيجيتنا الجديدة للممارسات البيئية والاجتماعية والحوكمة المؤسسية التي أعلنا عنها في سبتمبر 2022 كأحد ركائز استراتيجيتنا المؤسسية للعام 2025.`,
        name : "السيد توني كريبس",
        position : "العضو المنتدب والرئيس التنفيذي",
    },
    sectionOne : {
        rowOne : [
            {
                image : {
                    name : "environment.jpg",
                    alt : "Mills over a field",
                },
                title : "الحوكمة البيئية",
                subtitle : "تخصيص التمويل اللازم نحو اقتصاد عادل ومستدام",
                list : [
                    <p>دعم تحول عملائنا إلى اقتصاد أكثر استدامة وتنوعاً من خلال <b>منتجاتنا وخدماتنا</b></p>,
                    <p>زيادة <b>التمويل والاستثمارات المستدامة إلى 34 مليار ريال سعودي بحلول عام 2025،</b> بما يدعم رؤية المملكة 2030</p>,
                    <p>قياس الانبعاثات الكربونية لمحفظة أعمالنا، وضمان الوصول إلى <b>المحصلة الصفرية الكربونية بحلول عام 2060</b> أو قبل ذلك، مع التركيز بفعالية على التحول المتوازن</p>,
                    <p>مواءمة عملياتنا وسلسلة التوريد لدينا مع المستهدفات ومراحل الإنجاز الرئيسية الطموحة بحلول عام 2030، لتحقيق طموح <b>الوصول إلى المحصلة الصفرية الكربونية في عملياتنا بحلول العام 2035</b></p>,
                    <p>زرع <b>مليون شجرة</b> لتعويض<b> 0.9 مليون طن</b> من ثاني أكسيد الكربون</p>,
                ]
            },
            {
                image : null,
                title : "الحوكمة المؤسسية",
                subtitle : "الالتزام بمستوى عالٍ من الحوكمة المؤسسية، وإرساء مبادئ النزاهة والمسؤولية على مستوى عمليات صنع القرار بأكملها",
                list : [
                    <p>تنفيذ <b>هيكل الممارسات البيئية والاجتماعية والحوكمة المؤسسية</b></p>,
                    <p><b>دمج الممارسات البيئية والاجتماعية والحوكمة المؤسسية على مستوى جميع الإدارات والوظائف والموظفين،</b> بحيث يُراجع كل قرار مالي من منظور الممارسات البيئية والاجتماعية والحوكمة المؤسسية</p>,
                    <p>عقد شراكة مع هيئة دولية <b>لبناء أطر إعداد التقارير والإفصاح</b> من أجل تعزيز الشفافية</p>,
                    <p>الشروع في تنفيذ <b>إطار العمل المُحدث للحوكمة</b> وفق أفضل الممارسات الدولية</p>,
                ],
            }
        ],
        rowTwo : [
            {
                image : {
                    name : "social.jpg",
                    alt : "Woman explaining idea for group of people",
                },
                title : "الحوكمة الاجتماعية",
                subtitle : "أداء دور ريادي في إيجاد مجتمع شامل ومتنوع، بما يعود بالإيجاب على أصحاب المصلحة لدينا",
                list : [
                    <p>مواصلة تطوير قدراتنا الرقمية لبناء <b>قدرات مالية</b> مستدامة بين عملائنا وعلى مستوى المملكة</p>,
                    <p>السعي الطموح لأداء دورنا في <b>سد الفجوة القائمة في المدخرات الإقليمية</b></p>,
                    <p>الاستمرار في تشكيل وتطوير <b>الممارسات البيئية والاجتماعية والحوكمة المؤسسية وسوق التمويل المستدام</b> في جميع مناطق المملكة</p>,
                    <p>تذليل المعوقات أمام <b>المرأة وذوي الاحتياجات الخاصة</b> للمشاركة في الخدمات المالية، ومن بينها تمويل الشركات التي ترأسها الكفاءات النسائية</p>,
                ]
            }
        ]
    },
    titleSectionOne : {
        title : "عوامل التمكين الرئيسية"
    },
    sectionTwo : [
        {
            icon : {
                name : "education-and-future.svg",
                alt : "",
            },
            title : "التعليم ومهارات المستقبل- موظفون ملهمون وقادرون",
            subtitle : "نسعى في بنك الأول للتحول إلى أفضل مكان عمل في المنطقة من خلال تعزيز الشعور بالانتماء والتمكين والشمولية عند كافة الموظفين العاملين لدينا. ويمكن الوصول إلى جزء من ذلك عبر توظيف قوى عاملة تتميز بالتنوع وتكييف أساليبنا في العمل بما يتلاءم مع مصالح موظفينا ورفاهيتهم. كما نعكف في الأول على تطوير إطار عمل لبرنامج تدريبي قوي يُعنى بدمج معايير الحوكمة البيئية والاجتماعية والمؤسسية في ثقافة مؤسستنا.",
        },
        {
            icon : {
                name : "community.svg",
                alt : "",
            },
            title : "ازدهار المجتمع من خلال المسؤولية الاجتماعية للمؤسسات",
            subtitle : "يضع بنك الأول في مقدمة أولوياته تحقيق الازدهار المستدام للمملكة من خلال برامج الاستثمار والمشاركة المجتمعية والاستفادة من خبراته الجماعية ومنظومته الرقمية وقدرته على معالجة القضايا المجتمعية والبيئية العاجلة.",
        },
        {
            icon : {
                name : "risk-framework.svg",
                alt : "",
            },
            title : "إطار عمل المخاطر",
            subtitle : "بهدف مواكبة المستقبل، كان لا بد لنا في بنك الأول من تطوير نماذج المخاطر والسياسات والأنماط بغرض تقييم مدى التعرض لقطاعات ذات مخاطر تحول عالية. ويشمل ذلك قياس الانبعاثات الممولة في الأول وإجراء تحليل للسيناريو وإنشاء مسارات تدعم مسيرة التحول.",
        },
        {
            icon : {
                name : "strategic.svg",
                alt : "",
            },
            title : "الاتصالات الاستراتيجية والتسويق",
            subtitle : "نؤمن بأن نجاح استراتيجية بنك الأول يتعلق أولًا وأخيرًا بمدى إدراك جميع أصحاب المصلحة للرحلة التي نخوضها واستعدادهم للمشاركة فيها. ولا شك أن الإفصاح بكل شفافية عن كل ما نقوم به من خلال نشر تقرير الممارسات البيئية والاجتماعية والحوكمة المؤسسية واستراتيجية الممارسات البيئية والاجتماعية والحوكمة المؤسسية والالتزامات المستقبلية لبنك الأول والتي من شأنها أن تدفعنا نحو تحقيق هدفنا.",
        },
    ],
    titleSectionTwo : {
        title : "محاورنا",
        subtitle : "تستند استراتيجية الممارسات البيئية والاجتماعية والحوكمة المؤسسية إلى عدة محاور رئيسية، تسهم بدورها في توجيه إجراءات صنع القرار لدينا، ونقوم بإعداد تقرير عنها بشكل داخلي ومن خلال هذا التقرير:",
    },
    backgroundAndCardSection : {
        background : {
            src : "busines-strategy.jpg",
            alt : "A beautiful view of mills and fields",
        },
        card : {
            title : "استراتيجية أعمالنا التي تركز على الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : "بالتزامن مع الإعلان عن مبادرة السعودية الخضراء والإقرار الرسمي للمساهمات المحددة وطنيًا التي قدمتها المملكة في مؤتمر الأطراف السادس والعشرين المعني بتغير المناخ في العام 2021، أعددنا في بنك الأول استراتيجية طموحة لدعم مبادرات للممارسات البيئية والاجتماعية والحوكمة المؤسسية المشار إليها في المساهمات المحددة وطنيًا للملكة ورؤية السعودية 2030. لذا، دمجنا الممارسات البيئية والاجتماعية والحوكمة المؤسسية في الاستراتيجية المؤسسية الشاملة لبنك الأول، والتي من شأنها أن تحدد بوصلة التنفيذ على كل مستوى من المستويات التنظيمية.",
            image : {
                src : "business-strategy.jpg",
                alt : "A beautiful view of mills and sea",
            },
            button : {
                text : "أقرأ المزيد",
                path : pagesNames.business,
            }
        }
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.social
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.governance
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
};

export default strategyPageDataAr;